import * as z from "zod";

const LinearTeamSchema_ = z.object({
  id: z.string(),
  key: z.string(),
  name: z.string(),
});

export const LinearTeamSchema: z.ZodType<LinearTeam> = LinearTeamSchema_;
export interface LinearTeam extends z.infer<typeof LinearTeamSchema_> {}

export const getLinearTeams = {
  name: "getLinearTeams" as const,
  input: z.object({}),
  output: z.object({ teams: z.array(LinearTeamSchema) }),
};
